export const isProductionEnvironment = import.meta.env.MODE === 'production';
export const isStageEnvironment = ['staging', 'local-staging'].includes(import.meta.env.MODE);

export const playgroundIds = [
  'eda176df-0fd5-4fd3-bec6-55287881210c', // Loke
  '4eda68cc-9765-4f30-9595-55263111fba4', // Alejandro
  '3381a651-1070-4724-ba79-6a0ab8b53ac4', // Golnaz
  '3ce64bed-d46b-4f98-920f-ec227c2df67d', // Claudia
  '38792682-7eac-4be3-af9a-dc6c335d3bda', // Kiril
  'e4c82254-73f2-4424-9389-77ee815f2e80', // Bobby
  'ab06aee5-b1f9-4732-ac3f-1c697a8e6d31', // Raymond
  '01b7294f-dc56-4bca-80da-bda8a1f704b7', // Ketil
  '6e556b58-d5a9-4f69-84a7-d9e532d35828', // Tone Marit
];

export const bluViuNutritionR2ProdIds = [
  '01b7294f-dc56-4bca-80da-bda8a1f704b7', // Ketil
  '88cbb67b-0c3d-4de6-9270-c00561c4f784', // Kristine
  '57a8ff26-18fa-49ee-93cd-98934544c6b5',  // Pia
  '064b0b03-568a-464c-bfbc-60e07b6717e8', // Heidi 
  '8a7e6c54-4765-4856-81b3-9c74263867bf', //Charwaka
  'd57e3e0b-9d17-4c34-87fa-444d44bfb812' //Akshay
];
